module.exports = __webpack_public_path__ + "static/img/app2.e2a49a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app2.jpg
// module id = RLmm
// module chunks = 1